var _circle, _rect, _rect2, _circle2, _circle3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSteps30 = function SvgSteps30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 708,
    height: 31,
    viewBox: "0 0 708 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 16,
    r: 15,
    fill: "url(#paint0_linear_13243_112164)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 15,
    width: 643,
    height: 2,
    fill: "#ECC8BC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 17,
    width: 311,
    height: 2.00003,
    transform: "rotate(180 340 17)",
    fill: "#ECC8BC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 15,
    r: 14,
    fill: "#FFF0F0",
    stroke: "#ECC8BC",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 693,
    cy: 15,
    r: 14,
    fill: "#FFF0F0",
    stroke: "#ECC8BC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7992 19.8806L7.59922 15.7015L6.19922 17.0945L11.7992 22.6667L23.7992 10.7264L22.3992 9.33334L11.7992 19.8806Z",
    fill: "#FBFBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13243_112164",
    x1: -5.43932e-8,
    y1: 14.6028,
    x2: 41.6683,
    y2: 15.0412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })))));
};
export { SvgSteps30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzA4IiBoZWlnaHQ9IjMxIiB2aWV3Qm94PSIwIDAgNzA4IDMxIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSIxNSIgY3k9IjE2IiByPSIxNSIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzEzMjQzXzExMjE2NCkiLz4KPHJlY3QgeD0iMzYiIHk9IjE1IiB3aWR0aD0iNjQzIiBoZWlnaHQ9IjIiIGZpbGw9IiNFQ0M4QkMiLz4KPHJlY3QgeD0iMzQwIiB5PSIxNyIgd2lkdGg9IjMxMSIgaGVpZ2h0PSIyLjAwMDAzIiB0cmFuc2Zvcm09InJvdGF0ZSgxODAgMzQwIDE3KSIgZmlsbD0iI0VDQzhCQyIvPgo8Y2lyY2xlIGN4PSIzNTQiIGN5PSIxNSIgcj0iMTQiIGZpbGw9IiNGRkYwRjAiIHN0cm9rZT0iI0VDQzhCQyIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxjaXJjbGUgY3g9IjY5MyIgY3k9IjE1IiByPSIxNCIgZmlsbD0iI0ZGRjBGMCIgc3Ryb2tlPSIjRUNDOEJDIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTExLjc5OTIgMTkuODgwNkw3LjU5OTIyIDE1LjcwMTVMNi4xOTkyMiAxNy4wOTQ1TDExLjc5OTIgMjIuNjY2N0wyMy43OTkyIDEwLjcyNjRMMjIuMzk5MiA5LjMzMzM0TDExLjc5OTIgMTkuODgwNloiIGZpbGw9IiNGQkZCRkYiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8xMzI0M18xMTIxNjQiIHgxPSItNS40MzkzMmUtMDgiIHkxPSIxNC42MDI4IiB4Mj0iNDEuNjY4MyIgeTI9IjE1LjA0MTIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzZBNERCQyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGMjk5NEEiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4=";